import 'intersection-observer'
import scrollama from 'scrollama';
import $ from 'jquery';

let svg;
let h1;

export default () => {
  let $header = $('#shopify-section-header');
  let $window = $(window);
  let $steps   = $('.step');
  $window.on('scroll', () => {
    if ( $window.scrollTop() > 200 ) {
      $header.addClass('header-scroll');
    } else {
      $header.removeClass('header-scroll');
    }
  });


  if ($steps.length > 0) {
    const scroller = scrollama();

    scroller
      .setup({
        step: '.step',
        progress: true,
        offset: 0.7,
        threshold: 1
      })
      .onStepEnter(handleStepEnter)
      .onStepExit(handleStepExit)
      .onStepProgress(handleStepProgress);

    }
}

const handleStepEnter = (response) => {
  switch (response.element.dataset.scroll) {
    case 'video':
      let video = response.element.children[0].children[0];
      $(response.element).addClass('enter-animation');
      video.play();
      break;
    default:
      $(response.element).addClass('enter-animation');
  }
}

const handleStepExit = (response) => {
  switch (response.element.dataset.scroll) {
    case 'video':
      let video = response.element.children[0].children[0];
      video.pause();
      break;
    default:
  }
}

const handleStepProgress = (response) => {
  if(response.element.dataset.scroll == 'text') {
    $(response.element).find('svg').css('transform', `rotate(${(response.progress * 200).toFixed(2) / 2}deg)`);
  }
}